import script from "./categories-products.vue?vue&type=script&setup=true&lang=js"
export * from "./categories-products.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__